import { useEffect } from 'react';

export default function Logout() {
  useEffect(() => {
    // Clear all Supabase-related storage immediately
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (key.startsWith('sb-') || key.includes('supabase') || key.includes('socrates'))) {
        keysToRemove.push(key);
      }
    }
    keysToRemove.forEach(key => localStorage.removeItem(key));
    
    // Also clear session storage
    sessionStorage.clear();
    
    // Hard redirect to landing page
    window.location.href = '/';
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-stone-50 to-stone-100 flex items-center justify-center">
      <div className="text-center">
        <p className="text-stone-600">Signing out...</p>
      </div>
    </div>
  );
}

